{
  "name": "@altairgraphql/app",
  "description": "Contains the altair app",
  "version": "8.5.11",
  "author": "Samuel Imolorhe <hello@altairgraphql.dev> (https://altairgraphql.dev/)",
  "dependencies": {
    "@altairgraphql/api-utils": "workspace:*",
    "@altairgraphql/db": "workspace:*",
    "@altairgraphql/electron-interop": "workspace:*",
    "@altairgraphql/tauri": "workspace:*",
    "@angular/animations": "20.3.34",
    "@angular/cdk": "20.2.14",
    "@angular/common": "20.3.34",
    "@angular/core": "20.3.34",
    "@angular/forms": "20.3.34",
    "@angular/platform-browser": "20.3.34",
    "@angular/platform-browser-dynamic": "20.3.34",
    "@angular/platform-server": "20.3.34",
    "@angular/router": "20.3.34",
    "@apollo/client": "3.5.10",
    "@codemirror/autocomplete": "^6.20.3",
    "@codemirror/commands": "^6.11.1",
    "@codemirror/lang-javascript": "^6.2.5",
    "@codemirror/lang-json": "^6.0.2",
    "@codemirror/language": "^6.13.1",
    "@codemirror/lint": "^6.9.7",
    "@codemirror/search": "^6.7.2",
    "@codemirror/state": "^6.7.6",
    "@codemirror/view": "^6.43.14",
    "@emotion/css": "^11.13.5",
    "@fontsource/jetbrains-mono": "4.2.2",
    "@lezer/common": "1.4.0",
    "@lezer/highlight": "1.2.5",
    "@lezer/lr": "1.4.11",
    "@ngneat/hot-toast": "2.0.2",
    "@ngneat/overview": "1.0.0",
    "@ngneat/until-destroy": "8.0.4",
    "@ngrx/effects": "15.4.0",
    "@ngrx/store": "15.4.0",
    "@ngrx/store-devtools": "15.4.0",
    "@ngui/auto-complete": "3.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@sentry/electron": "^7.20.1",
    "@supabase/supabase-js": "1.29.4",
    "@webcomponents/custom-elements": "1.4.3",
    "abab": "2.0.6",
    "actioncable": "5.2.8",
    "ajv": "^8.20.0",
    "altair-graphql-core": "workspace:*",
    "angular-resizable-element": "^6.0.2",
    "angular-split": "^18.0.0",
    "apollo-cache-inmemory": "1.6.6",
    "apollo-link": "1.2.14",
    "apollo-link-http": "1.5.17",
    "aws-appsync-auth-link": "^3.0.8",
    "aws-appsync-subscription-link": "^3.1.5",
    "cm6-graphql": "0.0.15",
    "codemirror-graphql": "1.0.3",
    "codemirror-json-schema": "^0.6.1",
    "comlink": "4.3.1",
    "compare-versions": "^6.1.1",
    "cookie-parser": "1.4.7",
    "core-js": "3.6.5",
    "crypto-js": "3.3.0",
    "curlup": "1.0.0",
    "deepmerge": "4.2.2",
    "dexie": "^4.4.6",
    "dompurify": "^3.4.17",
    "express": "^4.22.3",
    "file-dialog": "0.0.8",
    "file-saver": "2.0.5",
    "fuse.js": "6.4.6",
    "graphql": "15.5.1",
    "graphql-language-service": "^5.7.0",
    "graphql-language-service-parser": "1.10.4",
    "graphql-language-service-types": "1.8.7",
    "graphql-query-compress": "1.2.4",
    "graphql-ws": "5.9.1",
    "hotkeys-js": "^3.13.15",
    "json-bigint": "^1.0.0",
    "json-schema": "^0.4.0",
    "lodash-es": "4.18.1",
    "loglevel": "1.8.1",
    "loglevel-plugin-prefix": "0.8.4",
    "lucide-angular": "^0.298.0",
    "marked": "^15.0.12",
    "memoizee": "0.4.17",
    "ng-zorro-antd": "^15.1.1",
    "ngrx-store-localstorage": "12.0.1",
    "ngx-cookie-service": "14.0.1",
    "ngx-markdown": "^14.0.1",
    "ngx-pipes": "^3.2.2",
    "ngx-sonner": "^3.1.0",
    "ngx-take-until-destroy": "5.4.0",
    "ngx-toastr": "^18.0.0",
    "nx": "17.1.3",
    "object-path": "0.11.8",
    "prettier": "^3.9.10",
    "rxjs": "7.8.1",
    "sanitize-html": "2.17.7",
    "subscriptions-transport-ws": "0.9.19",
    "sval": "0.4.9",
    "tslib": "2.0.0",
    "uuid": "^14.0.3",
    "zod": "catalog:",
    "zone.js": "0.15.1"
  },
  "devDependencies": {
    "@altairgraphql/iframe-sandbox": "workspace:*",
    "@analogjs/vite-plugin-angular": "^2.8.1",
    "@analogjs/vitest-angular": "^2.8.1",
    "@angular-eslint/builder": "20.3.0",
    "@angular-eslint/eslint-plugin": "20.3.0",
    "@angular-eslint/eslint-plugin-template": "20.3.0",
    "@angular-eslint/schematics": "20.3.0",
    "@angular-eslint/template-parser": "20.3.0",
    "@angular/build": "20.3.40",
    "@angular/cli": "20.3.40",
    "@angular/compiler": "20.3.34",
    "@angular/compiler-cli": "20.3.34",
    "@ngrx/schematics": "12.4.0",
    "@playwright/test": "catalog:",
    "@sentry/cli": "^3.8.0",
    "@types/actioncable": "5.2.11",
    "@types/chrome": "^0.0.332",
    "@types/codemirror": "^5.60.18",
    "@types/crypto-js": "^4.2.2",
    "@types/dompurify": "^3.2.0",
    "@types/electron": "^1.6.12",
    "@types/file-saver": "^2.0.7",
    "@types/firefox-webext-browser": "^109.0.0",
    "@types/graphql": "^14.5.0",
    "@types/json-bigint": "^1.0.4",
    "@types/json-schema": "^7.0.15",
    "@types/lodash-es": "^4.17.12",
    "@types/memoizee": "^0.4.12",
    "@types/mousetrap": "^1.6.15",
    "@types/node": "catalog:",
    "@types/object-path": "^0.11.4",
    "@types/sanitize-html": "^2.16.2",
    "@types/to-snake-case": "^1.0.2",
    "@types/uuid": "^9.0.8",
    "@types/zen-observable": "^0.8.7",
    "@typescript-eslint/eslint-plugin": "^8.71.2",
    "@typescript-eslint/parser": "^8.71.2",
    "@vitest/coverage-v8": "catalog:",
    "babel-plugin-transform-async-to-generator": "6.24.1",
    "babel-preset-env": "1.7.0",
    "babel-preset-react": "6.24.1",
    "chai": "4.2.0",
    "chai-as-promised": "7.1.2",
    "electron": "catalog:",
    "eslint": "^8.57.0",
    "eslint-config-altair": "workspace:*",
    "eslint-config-prettier": "^9.1.2",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-no-unsanitized": "^4.1.5",
    "eslint-plugin-prettier": "^5.5.7",
    "fake-indexeddb": "^4.0.2",
    "jest-chrome": "^0.8.0",
    "jsdom": "^28.1.0",
    "less": "^4.9.1",
    "ncp": "2.0.0",
    "ng-mocks": "14.13.4",
    "ngrx-store-freeze": "0.2.4",
    "protractor": "7.0.0",
    "react": "17.0.1",
    "rxjs-tslint-rules": "4.32.0",
    "start-server-and-test": "1.11.7",
    "ts-mocks": "2.6.1",
    "ts-node": "9.1.1",
    "typescript": "catalog:",
    "vite": "catalog:",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "catalog:"
  },
  "homepage": "https://altair-graphql.github.io/altair/",
  "license": "MIT",
  "main": "dist/browser/main.js",
  "private": true,
  "scripts": {
    "analyze": "ng build --stats-json && npx webpack-bundle-analyzer dist/stats.json",
    "analyze:prod": "ng build --aot --stats-json && npx webpack-bundle-analyzer dist/stats.json",
    "ng:build": "cross-env NODE_OPTIONS=--max-old-space-size=8192 pnpm ng build --aot --stats-json --output-hashing=none",
    "build": "node scripts/build.js",
    "lint": "ng lint",
    "new:component": "ng g component modules/altair/components/",
    "ng": "ng",
    "bootstrap": "pnpm build",
    "start": "ng serve",
    "sentry:sourcemaps:inject": "sentry-cli sourcemaps inject --org altair-graphql --project electron ./dist",
    "test": "vitest run && ng lint",
    "test-build": "ng lint && pnpm build && pnpm test-single-run",
    "test-single-run": "vitest run",
    "test:coverage": "vitest run --coverage",
    "test:watch": "vitest"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/altair-graphql/altair.git"
  }
}
